<template>
  <section>
    <!-- class="carouselContainer" -->
    <div v-if="data && data.length">
      <Carousel>
        <div v-for="d in data" :key="d.id">
          <router-link
            
            :to="{
              name: 'SessionsFind',
              query: {
                type: 'sessions',
                filter: d.name,
              },
            }"
          >
            <CategoryCard :data="d" />
          </router-link>
        </div>
      </Carousel>
    </div>
    <span class="text-xs text-gray-700" v-else>No data found.</span>
  </section>
</template>

<script>
import CategoryCard from "@/components/CategoryCard";
import { Carousel } from "@/components/t-components";

export default {
  name: "TopCategoriesCardListCarousel",
  components: {
    Carousel,
    CategoryCard,
  },
  props: {
    data: {
      type: Array,
    },
  },
};
</script>